import Icon from "@mdi/react";
import React from "react";
import { siGithub, siTelegram, siX } from "simple-icons";
import dante from "../../assets/dante-footer.png";
import dgpu from "../../assets/dgpu.png";
import pen from "../../assets/pen.png";
import "./contact.css";

const Contact = () => {
  return (
    <section className="contact">
      <div className="contact-inner container">
        <div className="contact-left">
          <img className="contact-dgpu" src={dgpu} alt="dgpu" />
          <img className="contact-dante" src={dante} alt="dante" />
        </div>

        <div className="contact-right">
          <img src={pen} alt="pen" className="contact-pen" />

          <div className="contact-right-content">
            <div className="contact-header">
              <h2 className="contact-title">Contact us</h2>
            </div>

            <div className="contact-item">
              <p className="contact-item-description">
                Join our community and help grow the DanteGPU ecosystem!
              </p>
              <a
                href=" https://t.me/+3d6uCNf5pX42YTY8"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button telegram-button"
              >
                <Icon path={siTelegram.path} size="18px" />
                <span>Join us on Telegram</span>
              </a>
            </div>

            <div className="contact-item">
              <p className="contact-item-description">
                Follow us and leave a positive comment!
              </p>
              <a
                href="https://twitter.com/DanteGPU"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button twitter-button"
              >
                <Icon path={siX.path} size="18px" />
                <span>Follow us on X</span>
              </a>
            </div>

            <div className="contact-item">
              <p className="contact-item-description">
                Star our project and keep track of its development!
              </p>
              <a
                href="https://github.com/dante-gpu"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button github-button"
              >
                <Icon path={siGithub.path} size="18px" />
                <span>Star Our Project</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
